module.exports = __webpack_public_path__ + "static/img/product-bottom-2.63d63d1b.png";